<template>
  <div class="main-view-padding has-header">
    <div class="header main" v-header-position-lock>
      <div class="align-left"></div>
      <div class="align-middle">
        <headerbuttonstack :state="headerButtons" />
      </div>
      <div class="align-right"></div>
    </div>
    <div
      style="
        font-size: 32px;
        text-align: left;
        color: #e51550;
        border-bottom: 1px solid #ccc;
        padding: 5px;
        font-weight: 400;
        margin-bottom: 25px;
      "
    >
        {{ $t('settings.employ.employmentModels') }}
    </div>

    <div>
      <table class="styled-table">
        <tr>
          <th>{{ $t('settings.groups.number') }}</th>
          <th>{{ $t('settings.groups.name') }}</th>
          <th>{{ $t('settings.groups.color') }}</th>
          <th class="center">{{ $t('settings.employ.defaultEmploymentModel') }}</th>
          <th class="center"> {{ $t('settings.employ.inUse') }}</th>
          <th class="center">{{ $t('settings.sync.status') }}</th>
          <th class="center">{{ $t('settings.ui.edit') }}</th>
          <th class="center">{{ $t('settings.employ.toggleActive') }}</th>
        </tr>
        <tr v-for="x in employmentModels" :key="x.id"  :style="{ backgroundColor: x.isActive ? 'transparent' : '#d3d3d3' }"  style="margin:0px;">
          <td>{{ x.number }}</td>
          <td>{{ x.name }}</td>
          <td style="display: flex; align-items: center; align-content: center; padding:9px 0px 8px 0px;">
            <div
              style="
                width: 15px;
                height: 15px;
                background-color: #f00;
                text-align: center;
                cursor: pointer;
                margin: 10px 0px 10px 22px;
              "
              v-bind:style="{ 'background-color': x.color }"
              v-on:click="toggleColorPicker(x)"
            ></div>
          </td>
          <td class="center"><i class="fas fa-check-circle checkbox" v-bind:class="{false: !x.isDefault}" v-on:click="toggleDefaultEmploymentModel(x)"></i></td>
          <td class="center">{{ x.usage }}</td>
          <td class="center" style="text-align: center;">
              <span v-if="x.isActive" class="text-success">
                    {{ $t('settings.employ.active') }}
              </span>
              <span v-else class="text-secondary">
                    {{ $t('settings.employ.inactive') }}
              </span>
          </td>
          <td class="center">
            <button class="icon-button" @click="openEditEntity(x)">
              <i class="fas fa-edit" ></i>
            </button>
          </td>
          <td class="center" style="padding:1px;">
            <button v-if="x.isActive && x.usage == 0"
                    class="btn btn-warning"
                    style="padding: 0px 8px; font-size: 12px; height: 28px; border-radius: 8px; font-family: DistrictProBook; color: var(--contrast-4);"
                    @click="updateEmploymentModel(x, 'toggleActive')">
                {{ $t('settings.employ.deactivate') }}
            </button>
            <button v-else-if="!x.isActive"
                    class="btn btn-success"
                    style="padding: 1px 5px; font-size: 10px; height: 16px; margin-top:-5px; line-height: 13px;"
                    @click="updateEmploymentModel(x, 'toggleActive')">
                {{ $t('settings.employ.activate') }}
            </button>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import button from "../uicomponents/button.vue";
export default {
  components: { button },
  name: "EmploymentModels",
  data() {
    return {
      loading: true,
      saves: false,
      employeesFull: [],
      employmentModels: [],
    };
  },
  created: function () {
    if (this.$store.state.jwt != undefined && this.$store.state.companyId != undefined) {
      this.refresh();
    }
  },
  mounted: function () {},
  computed: {
    ...mapGetters(["companyId"]),
    headerButtons() {
      let view = this;

      let state = {
        buttons: [],
          helperLinks: [
              {
                  title: view.$t('settings.employ.employmentModelsTitle'),
                  helperText: view.$t('settings.employ.employmentModelsHelpText'),
                  externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/kb/view/3130720268",
                  externalLabel: view.$t('settings.employ.learnMore'),
                  cancelLabel: view.$t('settings.employ.thanks'),
                  icon: "fa-file-export"
              },
              {
                  title: view.$t('settings.employ.getSupport'),
                  helperText: view.$t('settings.employ.getSupportHelpText'),
                  externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/group/11",
                  externalLabel: view.$t('settings.sync.contactSupport'),
                  cancelLabel: view.$t('global.ui.close')
              }
          ]
      };
      state.buttons.push({
        type: "block",
        icon: "fa-refresh",
        click: () => {
          view.refresh();
        },
          tooltip: view.$t('settings.employ.reloadData')
      });
      state.buttons.push({
        type: "block",
        icon: "fa-plus",
        click: ($event) => {
          view.openNewEmploymentModel($event);
        },
          tooltip: view.$t('settings.employ.createNew')
      });

      return state;
    },
    authorizationHeader() {
      return { 'Authorization': 'Bearer ' + this.$store.state.jwt };
    },
  },
  watch: {
    companyId: function (val, oldVal) {
      this.refresh();
    },
  },
  // methods that implement data logic.
  methods: {
    refresh: function (force = false) {
      let view = this;
      view.loading = true;
      view.loadEmploymentModels();
    },

    loadEmployees: async function () {
      const url = '/api/sec/employee/coredata';
      const params = {
        companyId: this.$store.state.companyId,
        basicData: 0,
      };
      const response = await this.axios({
        method: 'GET',
        url,
        params,
        headers: this.authorizationHeader,
      });
      this.employeesFull = response.data.data;
      this.countEmploymentModelUsage();
      this.$forceUpdate();
    },
    loadEmploymentModels: function () {
      let view = this;
      let params = { companyId: view.$store.state.companyId };
      view.$helpers
        .GetCall("/api/sec/employmentModels", params)
        .then((response) => {
          let data = response.data.data;
          let tmp = [];
          for (let i = 0; i < data.length; i++) {
            let item = {
              id: data[i].id,
              number: data[i].number,
              name: data[i].name,
              sorting: data[i].sorting,
              color: data[i].color,
              isActive: data[i].isActive,
              isDefault: data[i].isDefault
            };
            tmp.push(item);
          }
          view.employmentModels = tmp;
          view.loadEmployees();
        })
        .catch((e) => {
          view.loading = false;
          console.log(e);
        });
    },
    countEmploymentModelUsage: function () {
      this.employmentModels.forEach(model => {
        model.usage = 0;
      });
      const modelsIndex = {};
      this.employmentModels.forEach(model => {
        modelsIndex[model.id] = model;
      });
      this.employeesFull.forEach(employee => {
        if (employee.employmentModelId && modelsIndex.hasOwnProperty(employee.employmentModelId)) {
          modelsIndex[employee.employmentModelId].usage++;
        }
      });
    },

    openNewEmploymentModel(event) {
      let view = this;
      let dataEntries = [
        {
          label: view.$t('settings.employ.key') + ': ',
          key: "number",
          hidden: false,
          type: "numeric",
          value: 0,
          min: 0,
          max: 65535,
          styles: { width: "350px" },
        },
        {
          label: view.$t('settings.wage.label') + ': ',
          key: "name",
          hidden: false,
          type: "text",
          value: "",
          length: 128,
          styles: { width: "350px" },
        },
        //{label: 'Sortierungs Priorität', key: 'priority', hidden: false, type: 'slider', value: 1, slider: {value: 1, min: 1, max: 100}},
        { flexDivider: true, styles: { "margin-bottom": "23px" } },
      ];
      this.$helpers.OpenPopup({
        elRelative: event.currentTarget,
        type: "datafill",
        pointerDirection: 0,
        componentState: {
          entries: dataEntries,
          selectCallback: function (newEmploymentModel) {
            view.createEmploymentModel(newEmploymentModel);
          },
          errorCheck: {
            'number': (entries) => {
              if (!entries.hasOwnProperty('number') || entries.number === '') {
                return {
                  key: 'number',
                  label: view.$t('settings.groups.number'),
                  type: 'error',
                  text: view.$t('settings.wage.mustBeProvided')
                }
              } else if (view.employmentModels.find(f => parseInt(f.number) === parseInt(entries.number))) {
                return {
                  key: 'number',
                  label: view.$t('settings.groups.number'),
                  type: 'error',
                  text: view.$t('settings.groups.errAlreadyUsed')
                }
              } else {
                return null;
              }
            },
            'name': (entries) => {
              if (!entries.hasOwnProperty('name') || entries.name === '') {
                return {
                  key: 'name',
                  label: view.$t('settings.groups.name'),
                  type: 'error',
                  text: view.$t('settings.wage.mustBeProvided')
                }
              } else if (view.employmentModels.find(f => f.name === entries.name)) {
                return {
                  key: 'name',
                  label: view.$t('settings.groups.name'),
                  type: 'error',
                  text: view.$t('settings.groups.errAlreadyUsed')
                }
              } else {
                return null;
              }
            }
          },
        },
        header: view.$t('settings.employ.newEmploymentModel'),
        remainAfterSelect: false,
        expanded: true,
      });
    },
    openEditEntity(entity) {
      let view = this;

      let dataEntries = [
        {
          label: "id: ",
          key: "id",
          hidden: true,
          type: "text",
          value: entity.id,
          length: 128,
          styles: { width: "350px" },
        },
        {
          label: view.$t('settings.groups.number') + ': ',
          key: "number",
          hidden: false,
          type: "numeric",
          value: entity.number,
          min: 0,
          max: 65535,
          styles: { width: "350px" },
        },
        {
          label: view.$t('settings.groups.name') + ': ',
          key: "name",
          hidden: false,
          type: "text",
          value: entity.name,
          length: 128,
          styles: { width: "350px" },
        },
        { flexDivider: true, styles: { "margin-bottom": "23px" } },
      ];
      this.$helpers.OpenPopup({
        elRelative: null,
        type: "datafill",
        pointerDirection: 0,
        componentState: {
          entries: dataEntries,
          selectCallback: function (eEntity) {
            view.updateEmploymentModel(eEntity,'edit');
          },
          errorCheck: {
            number: (entries) => {
              if (
                entries.hasOwnProperty("number") &&
                view.employmentModels.find(
                  (f) => f.number !== entity.number && f.number === entries.number
                )
              )
                return {
                  key: "number",
                  type: "error",
                  text: view.$t('settings.groups.errAlreadyUsed'),
                };
              else return null;
            },
            name: (entries) => {
              if (
                entries.hasOwnProperty("name") &&
                view.employmentModels.find(
                  (f) => f.name !== entity.name && f.name === entries.name
                )
              )
                return {
                  key: "name",
                  type: "error",
                  text: view.$t('settings.groups.errAlreadyUsed'),
                };
              else return null;
            },
          },
        },
          header: view.$t('settings.employ.editEmploymentModel'),
        remainAfterSelect: false,
        centered: true,
        expanded: true,
      });
    },

    createEmploymentModel(newEmploymentModel) {
      let view = this;
      let url = "/api/sec/employmentModels";
      url = this.$helpers.appendParam(
        "companyId",
        this.$store.state.companyId,
        url,
        "/api/sec/employmentModels"
      );
      let payload = {
        companyId: this.$store.state.companyId,
        number: newEmploymentModel.number,
        name: newEmploymentModel.name,
        priority: 0, //newEmploymentModel.priority,
      };
      this.axios({
        method: "post",
        headers: {
          AUTHORIZATION: "Bearer " + view.$store.state.jwt,
        },
        url: url,
        data: payload,
      })
        .then((response) => {
            view.$helpers.success(
                view.$t('settings.employ.employmentModelCreated'),
                view.$t('settings.employ.employmentModelCreated')
            );
          view.refresh(true);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    updateEmploymentModel(model, updateType) {
      let view = this;
      let payload = {};
      let url = "/api/sec/employmentModels/" + model.id;
      if (updateType === 'toggleActive') {
        payload = {
          companyId: view.$store.state.companyId,
          isActive: !model.isActive
        };
      } else if (updateType === 'edit') {
        payload = {
          companyId: view.$store.state.companyId,
          number: model.number,
          name: model.name,
          priority: 0, // model.priority,
        };
      }
      url = view.$helpers.appendParam("companyId", view.$store.state.companyId, url);


      view.axios({
        method: "put",
        headers: {
          AUTHORIZATION: "Bearer " + view.$store.state.jwt,
        },
        url: url,
        data: payload,
      })
      .then((response) => {
          view.$helpers.success(
              view.$t('settings.employ.employmentModelUpdated'),
              view.$t('settings.employ.employmentModelUpdated')
          );
        if (updateType === 'edit') {
          view.refresh(true);
        }else if (updateType === 'toggleActive') {
          model.isActive = !model.isActive;
        }
      })
      .catch((error) => {
        console.error(error);
          if (error.response && error.response.status === 422) {
              let message = view.$t('settings.employ.errorUpdatingEmploymentModel');
              let bodyMessage = "...";
              if (error.response.data && error.response.data.message ===
                  "The EmploymentModel is still in use by employees") {
                  bodyMessage = view.$t('settings.employ.modelInUseByEmployees');
              }
              if (error.response.data && error.response.data.message ===
                  "This name is already taken by another entity") {
                  bodyMessage = view.$t('settings.employ.nameTaken');
              }
              if (error.response.data && error.response.data.message ===
                  "This number is already taken  by another entity") {
                  bodyMessage = view.$t('settings.employ.numberTaken');
              }
              view.$helpers.error(message, bodyMessage);
          } else {
              view.$helpers.error(
                  view.$t('settings.employ.errorUpdatingEmploymentModel'),
                  view.$t('settings.employ.errorUpdatingEmploymentModel')
              );
          }
      });
    },
    toggleDefaultEmploymentModel(editModel){
      let view = this;

      if (editModel.isDefault) {
        let url = '/api/sec/employmentModels/'+editModel.id;
        url = this.$helpers.appendParam("companyId", this.$store.state.companyId, url, '/api/sec/employmentModels/'+editModel.id);
        let payload = {
          companyId: this.$store.state.companyId,
          isDefault: false,
        }
        this.axios({
          method: 'put',
          headers: {
              'AUTHORIZATION': "Bearer "+view.$store.state.jwt
          },
          url: url,
          data: payload
        }).then(response => {
            view.$helpers.success(
                view.$t('settings.employ.employmentModelUpdated'),
                view.$t('settings.employ.employmentModelUpdated')
            );
            view.refresh(true);
        }).catch(function (error) {
            console.log(error)
        });
      } else {
        let promises = [];

        let url = '/api/sec/employmentModels/'+editModel.id;
        url = this.$helpers.appendParam("companyId", this.$store.state.companyId, url, '/api/sec/employmentModels/'+editModel.id);
        let payload = {
          companyId: this.$store.state.companyId,
          isDefault: true,
        }
        promises.push(
          this.axios({
            method: 'put',
            headers: {
                'AUTHORIZATION': "Bearer "+view.$store.state.jwt
            },
            url: url,
            data: payload
          })
        );
        view.employmentModels.forEach(model => {
          if (model.id !== editModel.id && model.isDefault) {
            let url = '/api/sec/employmentModels/'+model.id;
            url = this.$helpers.appendParam("companyId", this.$store.state.companyId, url, '/api/sec/employmentModels/'+model.id);
            let payload = {
              companyId: this.$store.state.companyId,
              isDefault: false,
            }
            promises.push(
              this.axios({
                method: 'put',
                headers: {
                    'AUTHORIZATION': "Bearer "+view.$store.state.jwt
                },
                url: url,
                data: payload
              })
            );
          }
        });
        Promise.all(promises).then(response => {
            view.$helpers.success(
                view.$t('settings.employ.employmentModelsUpdated'),
                view.$t('settings.employ.employmentModelsUpdated')
            );
            view.refresh(true);
        }).catch(function (error) {
            console.log(error)
        });
      }
    },

    toggleColorPicker(model, val = null) {
      let view = this;
      this.$helpers.OpenColorSelection(
        (color) => {
          model.color = color;
          view.saveColor(model);
        },
        {
          colorSelected: model.color,
          colorBlacklist: this.employmentModels.map((s) => {
            return { color: s.color, label: s.name };
          }),
        }
      );
    },
    saveColor(myObj) {
      let view = this;
      let url = "/api/sec/employmentModels/" + myObj.id;
      url = this.$helpers.appendParam(
        "companyId",
        this.$store.state.companyId,
        url,
        "/api/sec/employmentModels/" + myObj.id
      );
      let payload = {
        companyId: this.$store.state.companyId,
        color: myObj.color,
      };
      this.axios({
        method: "put",
        headers: {
          AUTHORIZATION: "Bearer " + view.$store.state.jwt,
        },
        url: url,
        data: payload,
      })
        .then((response) => {
            view.$helpers.success(
                view.$t('settings.employ.colorChanged'),
                view.$t('settings.employ.colorChanged')
            );
          view.refresh(true);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>

<!-- Add "scoped" attriemployeete to limit CSS to this component only -->
<style scoped>
.name-filter .fa-search {
  color: var(--contrast-4);
  position: absolute;
  top: 5px;
  left: 5px;
}

.half-width {
  width: 50%;
}

.fix-button-width {
  width: 150px;
}

.filter-input {
  margin-left: -45px;
  padding-left: 40px;
  width: calc(100% - 25px);
}

.list {
  width: calc(100% - 78px);
  margin: auto;
  height: 265px;
  box-shadow: inset 0 0 0 1px var(--contrast-3);
  overflow: hidden;
  position: absolute;
  border-radius: 5px;
}
.list .scroll-content {
  padding: 5px;
  overflow-y: auto;
  height: 265px;
}

.list-entry {
  height: 35px;
  margin-bottom: 2px;
  border-radius: 100px;
  cursor: pointer;
}

.list-entry:hover {
  background: var(--sub-menu);
  cursor: pointer;
}
.list-entry.selected {
  background: #e51550;
  cursor: pointer;
}
.list-entry.selected > .label,
.list-entry:hover > .label {
  color: var(--bg);
  cursor: pointer;
}
.list-entry.selected > .label > .label-small,
.list-entry.hover > .label > .label-small {
  color: var(--bg) !important;
  cursor: pointer;
}

.list-entry > .label {
  float: left;
  font-size: 14px;
  font-family: DistrictProBook;
  color: var(--contrast-4);
  padding-top: 6px;
  cursor: pointer;
}
.list-entry > .label > .label-small {
  cursor: pointer;
  color: var(--contrast-5);
}

.picture {
  float: left;
  border-radius: 100px;
  background: var(--contrast-1);
  margin-top: 5px;
  margin-left: 5px;
  margin-right: 10px;
  height: 25px;
  width: 25px;
}
.position-right {
  float: right;
  margin: 0;
  margin-right: -5px;
}
.pictureImg {
  border-radius: 100px;
  height: 25px;
  width: 25px;
}

/* width */
::-webkit-scrollbar {
  width: 10px;
  border-radius: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: var(--contrast-1);
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: var(--contrast-3);
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #aaaaaa;
}
.has-header > .has-header > .scrollbar-container {
  height: calc(100% - var(--header-height) - var(--tab-menu-height)) !important;
  overflow-x: hidden;
  top: var(--header-height);
  padding: 0px 14px;
}
</style>
